import React, { useState } from 'react';
import { Space, Typography, Select } from 'antd';
import DownloadAnnualReport from './components/DownloadAnnualReport';
import DownloadMonthlyReport from './components/DownloadMonthlyReport';
import DownloadFinancialStatement from './components/DownloadFinancialStatement';

export default function DownloadFinanceSheet({ nestedSubjects }) {
  const [sheetType, setSheetType] = useState('monthly');

  return (
    <Space>
      <div>
        <Typography.Text>下載報表：</Typography.Text>
        <Select
          value={sheetType}
          onChange={(value) => setSheetType(value)}
          style={{ width: '150px' }}
        >
          <Select.Option value="monthly">月報表</Select.Option>
          <Select.Option value="annual">財務收支表</Select.Option>
          <Select.Option value="statement">科目明細表</Select.Option>
        </Select>
      </div>
      {sheetType === 'monthly' && <DownloadMonthlyReport />}
      {sheetType === 'annual' && <DownloadAnnualReport />}
      {sheetType === 'statement' && (
        <DownloadFinancialStatement {...{ nestedSubjects }} />
      )}
    </Space>
  );
}
